import { render, staticRenderFns } from "./FinancesDisplay.vue?vue&type=template&id=764824c6&"
import script from "./FinancesDisplay.vue?vue&type=script&lang=js&"
export * from "./FinancesDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinancesDisplay.vue"
export default component.exports